<div id="underbox">

  <ng-container *ngIf="mode !== 'podcasts'">
    <a [routerLink]="linkToWatchFirstItem">
      <div [ngClass]="{'production-image' : main, 'production-image-list': !main}"
        [responsiveBackgroundImage]="production.thumbnail_landscape1"></div>
    </a>
  </ng-container>

  <div class="{{mainShowClip ? 'clip-margin' : ''}}" [ngClass]="main ? 'content-view-wrapper': ''">
    <div *ngIf="main && mainShowClip" class="content-container" [ngClass]="main? 'main': ''">
      <div class="show-logo-container">
        <a [routerLink]="linkToWatchFirstItem">
          <responsive-picture [src]="production.show.logo_square" alt="show logo" class="show-logo"></responsive-picture>
        </a>
      </div>

      <div class="show-info-container">
        <div class="show-info">
          <a [routerLink]="linkToWatchFirstItem">
            <h1>{{production.show.name | uppercase}}</h1>
          </a>
        </div>

        <div class="items">
          <div class="item">
            <div class="item-container">
              <summary>
                <a
                  [routerLink]="watchUrl(mainShowClip)">
                  {{mainShowClip.description}}
                </a>
              </summary>

              <tyt-playback-status-bar [item]="mainShowClip" (sessionChanged)="sessions[mainShowClip.id] = $event">
              </tyt-playback-status-bar>
              <div class="addendum">
                <div class="tyt-tags">
                  <tyt-content-badge
                    type="clip"
                    [premium]="mainShowClip.is_premium"
                    [unlocked]="mainShowClip.unlock_premium"></tyt-content-badge>
                </div>
                <ul class="facts">
                  <li>{{mainShowClip.duration | duration}}</li>
                  <li>
                    <tyt-comments-count identifier="vod_{{mainShowClip.id}}"></tyt-comments-count>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="{{main ? 'main': ''}}"
      [ngClass]="mode === 'podcasts' ? 'content-container podcasts' : 'content-container'">
      <div class="show-logo-container">
        <a [routerLink]="linkToWatchFirstItem">
          <responsive-picture [src]="production.show.logo_square" alt="show logo" class="show-logo"></responsive-picture>
        </a>
      </div>
      <div [ngClass]="mode === 'podcasts' ? 'show-info-container podcasts': 'show-info-container card-height'">
        <div class="show-info">
          <a [routerLink]="linkToWatchFirstItem">
            <h1>{{production.show.name | uppercase}}</h1>
          </a>
        </div>

        <div class="items">
          <div class="item" *ngFor="let item of items">

            <div class="item-container">
              <summary [ngClass]="!main ? 'list': ''">
                <a
                  [routerLink]="watchUrl(item)">
                  {{item.description}}
                </a>

              </summary>

              <tyt-playback-status-bar [item]="item" (sessionChanged)="sessions[item.id] = $event">
              </tyt-playback-status-bar>
              <div class="addendum">
                <div class="tyt-tags">
                  <tyt-content-badge
                    [type]="mode"
                    [premium]="item.is_premium"
                    [unlocked]="item.unlock_premium"
                    ></tyt-content-badge>
                </div>
                <ul class="facts">
                  <li>{{production.date_simple | date : 'mediumDate'}}</li>
                  <li>{{item.duration | duration}}</li>
                  <li>
                    <tyt-comments-count identifier="vod_{{item.id}}"></tyt-comments-count>
                  </li>
                </ul>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

</div>
